import {Component, ComponentOptions} from "@mecatran-components/component";
import {Input} from "@mecatran-components/input";

export class InOutbandButton extends Component{
    constructor(odOptions){
        var odOptions = odOptions || {};
        var componentOptions = new ComponentOptions();
        componentOptions.setDomOptions(odOptions.domOptions);
        super(componentOptions);

        this.initInOutbandButton();
    }

    /* ======================================= */
    /* PRIVATE                                 */
    /* ======================================= */

    isInput(element){
        return (element.tagName === 'INPUT');
    }
    
    createInButton(value, classList){
        var options = { 
            type : 'button',
            classList,
            value 
        }
        var inbandButton = new Input(options);
        return inbandButton;
    }

    initInOutbandButton(){

        var inbandButton = this.createInButton('Aller', ['in','active']);
        this.addSubComponent(inbandButton,'inband');

        var outbandButton = this.createInButton('Retour',['out']);
        this.addSubComponent(outbandButton, 'outband');

        this.build();
    }

    activate(element){
        element.classList.add('active')
    }

    deActivateAll(element){
        var storageManager = this.getStorageManager();
        var inband = storageManager.getComponents('inband')[0];
        inband.getDomNode().classList.remove('active');
        var outband = storageManager.getComponents('outband')[0];
        outband.getDomNode().classList.remove('active');
    }

    onButtonClick(event){
        var element = event.target; 
        this.deActivateAll();
        this.activate(element);

        var detail = (element.classList.contains('in')) ? 'in' : 'out';
        this.emitCustomEvent('clickEvent', detail);
    }

    onClickEvent(event){
        console.log(event.detail)
    }


    /* ======================================= */
    /* OVERLOAD                                */
    /* ======================================= */  

    createContainerNode(domOptions){
        var div = document.createElement('div');
        div.classList.add('inband-outband');
        InOutbandButton.setDomOptions(div,domOptions)
        return div;
    }

    createContentNode(){ return }

    defineEventListeners(eventManager){
        eventManager.on('click', this.isInput, this.onButtonClick.bind(this), false);
        eventManager.on('clickEvent', ()=>true, this.onClickEvent.bind(this), false);
    };

    /* ======================================= */
    /* PUBLIC                                  */
    /* ======================================= */    
    
    

    /* ======================================= */
    /* STATIC                                  */
    /* ======================================= */    
    static setDomOptions(node, domOptions){
        var domOptions = domOptions || {};
        if (domOptions.style){
            var strStyle = OriginDestination.serializeObject(domOptions.style); 
            node.setAttribute('style',strStyle)
        }
        if (domOptions.classList) domOptions.classList.forEach(className => node.classList.add(className));
        if (domOptions.id) node.setAttribute('id',domOptions.id);
    }

    static serializeObject(object){
        var str = '';
        Object.entries(object).forEach(([k,v])=> str+= `${k}:${v}`)
        return str;
    }
}
